<template>

	<div class="directory-listing-nav" v-if="navigation && navigation.length > 0">
		<div class="grid grid--auto--not-phab grid--middle--not-phab grid--nowrap--not-phab">
			<div class="grid__item grid__item--space">

				<ul class="grid grid--auto grid--middle grid--b15">
					<template v-for="(item, key) in navigation">
						<li class="grid__item">
							<span class="directory-listing-nav__item" :class="{
								'directory-listing-nav__item--ancestor' : key != navigation.length - 1,
								'directory-listing-nav__item--current' : key == navigation.length - 1
							}" :key="item.id" @click="navigateToFolder(item)">
								<span>{{item.name}}</span>
							</span>
						</li>
						<li class="grid__item" v-if="key != navigation.length - 1">
							<span class="fonticon fonticon--chevron--right fs--8"></span>
						</li>
					</template>
				</ul>

			</div>
			<div v-if="hasDownloadBtn || !readOnly" class="grid__item hr--phab" :class="{
				'min-h--40' : readOnly,
				// <attr class='min-h--40' />
			}">

				<template v-if="readOnly">
					<theme-btn v-if="currentDirectoryId  && currentDirectory.hasChildren" @click="downloadCurrentDirectory()">
						<span>Download All</span>
					</theme-btn>
				</template>


				<template v-else>
					<div class="grid grid--g16 grid--b0 grid--auto grid--nowrap grid--middle">
						<div class="grid__item">
							<span class="fonticon fonticon--new-folder clickable fc-pal--link fs--20c" @click="$emit('newFolder')"></span>
						</div>
						<div class="grid__item">
							<span v-if="currentDirectoryId  && currentDirectory.hasChildren" class="fonticon fonticon--download clickable fc-pal--link fs--20c" @click="downloadCurrentDirectory()"></span>
						</div>
					</div>
				</template>

			</div>
		</div>
	</div>
</template>

<script>
import { findIndex, slice } from 'lodash';

import Btn from '../atoms/Btn';
import ThemeBtn from '../atoms/ThemeBtn';

export default {
	name: 'DirectoryListingNav',
	components: {
		Btn,
		ThemeBtn
	},
	data () {
		return {
		}
	},
	props: {
		navigation: Array,
		hasDownloadBtn: {
			type: Boolean,
			default: true
		},
		readOnly: {
			type: Boolean,
			default: true
		},
	},
  watch: {
  },
	computed: {
		currentDirectory: function()
		{
			var self = this;
			return self.navigation[self.navigation.length - 1];
		},
		currentDirectoryId: function()
		{
			var self = this;
			return self.currentDirectory && self.currentDirectory.hasOwnProperty('id') ? self.currentDirectory.id : null;
		}
	},
	created: function()
	{
	},
	mounted: function()
	{
		var self = this;
	},
	methods: {
		navigateToFolder: function(item)
		{
			var self = this;

			if(item.id !== self.currentDirectoryId)
			{
				var index = Math.max(0, findIndex(self.navigation, {id: item.id}));
				self.$emit('navigateToFolder', slice(self.navigation, 0, index + 1));
			}
		},
		downloadCurrentDirectory: function()
		{
			var self = this;

			if(!self.currentDirectoryId) { return; }

			var directory = self.currentDirectoryId;	// Keep copy as reference

			self.$api.getAsset(directory).then((success) => {

				self.trackEvent([
					'directory-downloaded',
					directory,
					self.$root.$data.user ? self.$root.$data.user.trackName : null,
					0,
					false
				]);

				if(success.data.isZip) {
					window.location.assign(self.$apiPath + '/download/asset/zip/' + parseInt(success.data.id, 10));
				} else {
					window.location.assign(self.$apiPath + '/download/asset/' + parseInt(success.data.id, 10));
				}
			}).catch((error) => {
				console.log(error);
			});

		},
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".directory-listing-nav";
	#{$c}
	{
		@include extend(h6);

		&__item
		{
			&--ancestor
			{
				cursor: pointer;

				&:hover
				{
					color: palette(link);
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/DirectoryListingNav.vue